export default __webpack_public_path__ + "static/media/profileImageForSaivani.16b74247.png";